export const AnalyticsEvents = Object.freeze({
	publishPoll: 'publish_poll',
	finishPoll: 'finish_poll',
	vote: 'vote',
	cancelVote: 'cancel_vote',
	copyPollLink: 'copy_poll_link',
	setOptions: 'set_options',
	isMultipleChoice: 'is_multiple_choice',
	setCancelVote: 'set_cancel_vote',
	setTimeLimit: 'set_time_limit',
	downloadResult: 'download_result',
});

export const AnalyticsCategories = Object.freeze({
	pollSettings: 'poll_settings',
	polls: 'polls',
});
